import { styled, Switch, SwitchProps } from "@mui/material";
import { isMobile } from "react-device-detect";
import { MdLightMode, MdDarkMode } from "react-icons/md";

export const  ThemeSwitch = styled((props: SwitchProps) => {
  const isChecked = Boolean(props.checked);

  return (
    <div style={{ position: "relative", width: 80, height: 40}}>
      {}
      <Switch disableRipple sx={{ padding: 0, width: 80, height: 40 }} {...props} />

      {}
      <div
        style={{
          position: "absolute",
          left: "0%",
          right: "50%",
          top: 0,
          bottom: 0,
          background: isChecked ? "transparent" : "#FFFFFF",
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none", 
        }}
      >
        <MdLightMode size={24} color={isChecked ? "#FFFFFF" : "#004B87"} />
      </div>

      {}
      <div
        style={{
          position: "absolute",
          left: "50%",
          right: "0%",
          top: 0,
          bottom: 0,
          background: isChecked ? "#FFFFFF" : "transparent",
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none", 
        }}
      >
        <MdDarkMode size={24} color={isChecked ? "#007749" : "#80868E"} />
      </div>
    </div>
  );
})(({ theme }) => ({
  "& .MuiSwitch-root": {
    width: 80,
    height: 40,
    padding: 0,
    position: "absolute",
    backgroundColor: "transparent",
    top: 0,
    left: 0,
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    zIndex: 2,
  },
  "& .MuiSwitch-thumb": {
    width: 40,
    height: 40,
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 8,
    backgroundColor: "transparent",
    opacity: 1,
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
  backgroundColor: "transparent !important", 
},
}));
